import { render, staticRenderFns } from "./MallHome.vue?vue&type=template&id=7b9a0702&scoped=true&"
import script from "./MallHome.vue?vue&type=script&lang=js&"
export * from "./MallHome.vue?vue&type=script&lang=js&"
import style0 from "./MallHome.vue?vue&type=style&index=0&id=7b9a0702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9a0702",
  null
  
)

export default component.exports